module.exports = __webpack_public_path__ + "img/40_69_001_860.f966ea78.jpg";